import { FormikHelpers } from 'formik'
import React from 'react'

import { LoanFilterLimits } from '@utils/getCategoryLoanFilterLimits'

import { LoanTableFilterFormValues } from '@appTypes/App.interface'
import { LoanPurpose } from '@appTypes/LoansApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'

import LoansTableFilterAccordion from '@components/LoansTableFilterAccordion'
import LoansTableFilterForm from '@components/LoansTableFilterForm/LoansTableFilterForm'
import { getLoansValidationSchema } from '@components/LoansTableFilterForm/LoansTableFilterForm.validation'

interface LoanTableFilterProps {
    loanAmount: number,
    loanFilterLimits: LoanFilterLimits,
    loanTerm: number
}

const getLoanAmountDisplay = (loanAmount: number) => {
    return loanAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const UnscoredTableFilter = ({
    loanFilterLimits,
    loanAmount,
    loanTerm,
}: LoanTableFilterProps) => {
    const [isAccordionOpen, setAccordionOpen] = React.useState(true)
    const { updateAppQueryState } = useAppQueryState()

    const validationSchema = React.useMemo(() => {
        return getLoansValidationSchema({
            minAmount: loanFilterLimits.loanAmount.min,
            maxAmount: loanFilterLimits.loanAmount.max,
            minTerm: loanFilterLimits.loanTerm.min,
            maxTerm: loanFilterLimits.loanTerm.max,
        })
    }, [loanFilterLimits])

    async function onFormSubmit(
        formValues: LoanTableFilterFormValues,
        formikHelpers: FormikHelpers<LoanTableFilterFormValues>
    ) {
        updateAppQueryState({
            loanAmount: formValues.loanAmount.toString(),
            loanTerm: formValues.loanTerm.toString(),
        })
    }

    return (
        <LoansTableFilterAccordion
            title="Loan details"
            subtitle={`£${getLoanAmountDisplay(
                loanAmount
            )} over ${loanTerm} months`}
            isOpen={isAccordionOpen}
            onFilterPress={() => setAccordionOpen(prev => !prev)}
        >
            <LoansTableFilterForm
                formValues={{
                    loanAmount,
                    loanTerm,
                    loanPurpose: LoanPurpose.Other,
                }}
                loanFilterLimits={loanFilterLimits}
                showLoanPurpose={false}
                onFormSubmit={onFormSubmit}
                validationSchema={validationSchema}
            />
        </LoansTableFilterAccordion>
    )
}

export default UnscoredTableFilter
